// extracted by mini-css-extract-plugin
module.exports = {"textLink":"LinkBankingTransparency_textLink__34hf3","link":"LinkBankingTransparency_link__6fTj_"};